"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionNodes = exports.QuestionNodes = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const create_1 = require("./create");
const other_1 = require("./other");
const createRootNode_1 = require("./scaffold/vs/createRootNode");
const createFromTdpNode_1 = require("./scaffold/vsc/createFromTdpNode");
const createRootNode_2 = require("./scaffold/vsc/createRootNode");
tslib_1.__exportStar(require("./constants"), exports);
tslib_1.__exportStar(require("./create"), exports);
tslib_1.__exportStar(require("./inputs"), exports);
tslib_1.__exportStar(require("./options"), exports);
class QuestionNodes {
    createProject(platform) {
        if (platform === teamsfx_api_1.Platform.VS)
            return (0, createRootNode_1.scaffoldQuestionForVS)();
        return (0, createRootNode_2.scaffoldQuestionForVSCode)(platform);
    }
    createFromTdp(platform) {
        return (0, createFromTdpNode_1.createFromTdpNode)(platform);
    }
    createSampleProject() {
        return (0, create_1.createSampleProjectQuestionNode)();
    }
    addWebpart() {
        return (0, other_1.addWebPartQuestionNode)();
    }
    selectTeamsAppManifest() {
        return (0, other_1.selectTeamsAppManifestQuestionNode)();
    }
    validateTeamsApp() {
        return (0, other_1.validateTeamsAppQuestionNode)();
    }
    previewWithTeamsAppManifest() {
        return (0, other_1.previewWithTeamsAppManifestQuestionNode)();
    }
    listCollaborator() {
        return (0, other_1.listCollaboratorQuestionNode)();
    }
    grantPermission() {
        return (0, other_1.grantPermissionQuestionNode)();
    }
    deployAadManifest() {
        return (0, other_1.deployAadManifestQuestionNode)();
    }
    convertAadToNewSchema() {
        return (0, other_1.convertAadToNewSchemaQuestionNode)();
    }
    createNewEnv() {
        return (0, other_1.createNewEnvQuestionNode)();
    }
    copilotPluginAddAPI() {
        return (0, other_1.copilotPluginAddAPIQuestionNode)();
    }
    apiKey() {
        return (0, other_1.apiSpecApiKeyQuestion)();
    }
    oauth() {
        return (0, other_1.oauthQuestion)();
    }
    addPlugin() {
        return (0, other_1.addPluginQuestionNode)();
    }
    regeneratePlugin() {
        return (0, other_1.regeneratePluginNode)();
    }
    metaOSExtendToDA() {
        return (0, other_1.metaOSExtendToDAQuestionNode)();
    }
    uninstall() {
        return (0, other_1.uninstallQuestionNode)();
    }
    syncManifest() {
        return (0, other_1.syncManifestQuestionNode)();
    }
    kiotaRegenerate() {
        return (0, other_1.kiotaRegenerateQuestion)();
    }
    addAuthAction() {
        return (0, other_1.addAuthActionQuestion)();
    }
    addKnowledge() {
        return (0, other_1.addKnowledgeQuestionNode)();
    }
    setSensitivityLabel() {
        return (0, other_1.setSensitivityLabelNode)();
    }
    share() {
        return (0, other_1.shareNode)();
    }
    removeSharedAccess() {
        return (0, other_1.removeSharedAccessNode)();
    }
}
exports.QuestionNodes = QuestionNodes;
exports.questionNodes = new QuestionNodes();
//# sourceMappingURL=index.js.map